import React from 'react';
const Card = ({
  svgsrc,
  title = '',
  subTitle = '',
  classes = '',
  svgClasses = '',
  subText,
  clickable = false,
  handler = () => { },
  titleClasses = '',
  subTitleClasses = ''
}) => {

  return (
    <div
      className={
        'flex rounded-ds-md border border-gray-250 bg-white p-5 shadow-ds-sm transition-all duration-200 ease-[cubic-bezier(.22,1,.36,1)] ' +
        classes +
        `${clickable ? ' cursor-pointer hover:border-blue-200 hover:shadow-ds-md focus:outline-none focus:ring-2 focus:ring-blue-600 focus:ring-offset-2 focus:ring-offset-white' : ''}`
      }
      onClick={handler}
      role={clickable ? 'button' : undefined}
      tabIndex={clickable ? 0 : undefined}
      onKeyDown={
        clickable
          ? (e) => {
              if (e.key === 'Enter' || e.key === ' ') {
                e.preventDefault();
                handler(e);
              }
            }
          : undefined
      }
    >
      <img src={svgsrc} className={'h-5 w-5 mr-3 mt-0.5 ' + svgClasses} alt='' />
      <div>
        <div className={'font-semibold text-ts-md text-gray-900 ' + titleClasses}>{title}</div>
        <div className={'mt-1 text-xs text-gray-600 ' + subTitleClasses}>{subTitle}</div>
        {subText && <div className='mt-1 text-ts-md leading-relaxed text-gray-600'>{subText}</div>}
      </div>
    </div>
  );
};

export default Card;
